//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosGet, axiosPost } from '../../axios/axios.js'
import { downloadFile } from '../helpers.js'
import UpdatesManager from '../UpdatesManager.js'

export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-download'
    },
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'md'
    },
    asyncOptions: {
      type: Array,
      required: true
    },
    isSystemReportButton: {
      type: Boolean,
      default: false
    },
    buttonType: {
      type: String,
      default: 'export' // 'export' || 'import'
    }
  },
  data: function () {
    return {
      loading: false,
      updatesManager: null,

      asyncId: null,

      asyncPercent: 0,
      asyncActivityText: '',
      asyncStatus: null,

      importInputId: 'asyncImportInput' + Math.random().toString(36).substring(2, 15)
    }
  },
  computed: {
    isAsyncLoading: function () {
      return this.asyncId !== null && this.loading
    }
  },
  beforeDestroy: function () {
    if (this.updatesManager) {
      this.updatesManager.stopUpdates('component destroyed')
      this.updatesManager.destroy()
    }
  },
  methods: {
    updateAsyncStatus: function () {
      if (this.asyncId != null) {
        return axiosGet({
          url: '/service/reportdata/getasync?id=' + this.asyncId + '&getresult=false',
          onSuccess: (response) => {
            if (response.data.status === 'ready') {
              if (this.buttonType === 'import') {
                this.loadAsyncImportResult()
              } else if (this.buttonType === 'export') {
                this.loadAsyncReport()
              }
              this.clearAsyncExport()
              this.updatesManager.stopUpdates('async export finished')
              this.updatesManager.destroy()
            } else {
              this.asyncPercent = response.data.readyPercent < 100 ? response.data.readyPercent : response.data.formattingPercent
              this.asyncActivityText = response.data.status === 'stopping' ? 'Остановка...' : response.data.activityMessage
              this.asyncStatus = response.data.status
            }
          },
          onFailure: error => {
            this.$q.notify({
              type: 'negative',
              message: error.message || 'Ошибка выполнения операции',
              progress: true,
              timeout: 8000
            })
            this.clearAsyncExport()
            this.updatesManager.stopUpdates('async export error')
            this.updatesManager.destroy()
            this.loading = false
          }
        })
      } else {
        return Promise.reject(new Error('Async export ID is not set'))
      }
    },
    stopAsyncExport: function () {
      return axiosGet({
        url: '/service/reportdata/stopreportasync?id=' + this.asyncId,
        onSuccess: (response) => {

        },
        onFailure: error => {
          this.$q.notify({
            type: 'negative',
            message: error.message || 'Ошибка выполнения операции',
            progress: true,
            timeout: 8000
          })
        }
      })
    },
    clearAsyncExport: function () {
      this.asyncId = null
      this.asyncPercent = 0
      this.asyncActivityText = ''
      this.asyncStatus = null
    },
    handleClick: function (asyncOption) {
      if (this.buttonType === 'export') {
        this.loadData(asyncOption)
      } else if (this.buttonType === 'import') {
        this.uploadData(asyncOption)
      }
    },
    loadData: function (asyncOption) {
      let url = '/service/delta/reportSource/'

      const formData = new FormData()

      formData.append('reportKey', asyncOption.reportKey)

      if (asyncOption.formDataProps) {
        Object.keys(asyncOption.formDataProps).forEach((key) => {
          if (asyncOption.formDataProps[key]) {
            formData.append(key, asyncOption.formDataProps[key])
          }
        })
      }

      if (asyncOption.templateXlsFile && asyncOption.filteredTableExport) {
        this.$q.notify({
          type: 'negative',
          message: 'Ошибка: системный отчёт некорректно настроен',
          progress: true,
          timeout: 8000
        })
        return
      } else if (asyncOption.type === 'filteredTableExport') {
        if (asyncOption.notAsync) {
          url += `filteredTableExport/${asyncOption.format}`
        } else {
          url += `filteredTableExportAsync/${asyncOption.format}`
        }
      } else if (asyncOption.type === 'customReport') {
        url += 'customReport'
      } else if (asyncOption.type === 'templateXlsFile') {
        url += 'templatedXlsReport?template=' + asyncOption.templateXlsFile
      } else {
        url += 'gridTemplatedXlsReport'
      }

      if (asyncOption.type !== 'filteredTableExport' || asyncOption.notAsync) {
        if (asyncOption.notDownloadResult) {
          this.loading = true
          axiosPost({
            url: url,
            data: formData,
            responseType: 'blob',
            onSuccess: (response) => {
              this.$emit('export-success')
            },
            onFailure: async (error) => {
              let message = 'Ошибка выполнения операции'
              if (!error.response) {
                message = error.message || message
              } else {
                const responseText = await error.response.data.text()
                const response = JSON.parse(responseText)
                message = response.message || message
              }
              this.$q.notify({
                type: 'negative',
                message: message,
                progress: true,
                timeout: 8000
              })
            }
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.loading = true
          downloadFile(url, () => {
            this.loading = false
          }, this, 'POST', formData)
            .then(result => {
              this.$emit('export-success')
              this.$emit('download-success')
            })
        }
      } else {
        this.loading = true

        formData.append('clear', false) // TODO: определить, в каких случаях добавлять этот параметр

        this.startAsyncProcess(url, formData)
      }
    },
    uploadData: function (asyncOption) {
      const inputEl = document.getElementById(`${this.importInputId}`)
      inputEl.click()
    },
    uploadFile: function (event) {
      console.log('File selected for upload:', event.target.files)
      const newFile = event.target.files[0]

      const url = this.asyncOptions[0] && this.asyncOptions[0].url ? this.asyncOptions[0].url : null

      this.loading = true

      const formData = new FormData()
      formData.append('file', newFile)

      this.startAsyncProcess(url, formData).finally(() => {
        const inputEl = document.getElementById(`${this.importInputId}`)
        inputEl.value = ''
      })
    },
    startAsyncProcess: async function (url, formData) {
      this.loading = true

      console.log('Starting async process, url:', url)

      return axiosPost({
        url: url,
        data: formData,
        onSuccess: response => {
          this.asyncId = response.data.id
          this.updatesManager = new UpdatesManager({
            autoUpdate: true,
            autoUpdateTimeout: 1000,
            updateFn: () => {
              return this.updateAsyncStatus()
            },
            skipUpdateFn: () => {
              return !this.asyncId
            },
            componentName: 'TableAsyncButton'
          })
          this.updatesManager.onUpdate()
        },
        onFailure: async (error) => {
          let message = 'Ошибка выполнения операции'
          if (!error.response) {
            message = error.message || message
          } else {
            const responseText = await error.response.data.text()
            const response = JSON.parse(responseText)
            message = response.message || message
          }
          this.$q.notify({
            type: 'negative',
            message: message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        if (!this.asyncId) {
          this.loading = false
        }
      })
    },
    loadAsyncImportResult: function () {
      const url = `service/reportdata/getasync?id=${this.asyncId}&clear=true&getresult=true`
      return axiosGet({
        url: url,
        onSuccess: (response) => {
          this.$emit('import-finished', response.data)
        },
        onFailure: ''
      }).finally(() => {
        this.loading = false
      })
    },
    loadAsyncReport: function () {
      const url = '/service/delta/reportSource/getFilteredTableExportAsync?id=' + this.asyncId
      this.loading = true
      downloadFile(url, () => {
        this.loading = false
      }, this, 'GET')
        .then(result => {
          this.$emit('export-success')
          this.$emit('download-success')
        })
    }
  }
}
